import { jsx } from 'react/jsx-runtime';
import WhenValidGrandChildren from '../../../utility/WhenValidGrandChildren.mjs';
import BaseHelperText from '../BaseHelperText.mjs';
import { useTextFieldContext } from './context.mjs';

const TEXT_FIELD_HELPER_TEXT_NAME = "TextFieldHelperText";
function HelperText({
  icon: iconFromProps,
  id,
  __scopeTextField,
  children,
  ...props
}) {
  const {
    state,
    disabled,
    setDescribedBy
  } = useTextFieldContext(TEXT_FIELD_HELPER_TEXT_NAME, __scopeTextField);
  return /* @__PURE__ */ jsx(WhenValidGrandChildren, { children: /* @__PURE__ */ jsx(
    BaseHelperText,
    {
      ...props,
      state,
      disabled,
      setDescribedBy,
      children
    }
  ) });
}

export { HelperText as default };
//# sourceMappingURL=HelperText.mjs.map
